<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import SelectCourse from "@/components/Dashboard/Utilities/Config/SelectCourse.vue";
import useQrCodeView from "@/scripts/Utilities/DrivingRangeQRCodeView";
import { watch } from "vue";

const {
  course,
  loading,
  generatingQrCode,
  isFormValid,
  generateQrCode,
  downloadQrCode,
  hasQrCodeUrl,
  qrCodeUrl,
  clearQrCodeUrl,
} = useQrCodeView();

watch(course, clearQrCodeUrl, { immediate: true });
</script>

<template>
  <ContentHeader name="QR Code" :middleDots="true" />
  <section class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="form-group">
            <div class="ml-2">
              <SelectCourse v-model="course" />
            </div>

            <div class="input-group input-group-md">
              <button
                @click="generateQrCode"
                type="button"
                class="btn m-1 btn-info tm-btn-red fixed-width-button"
                :disabled="!isFormValid || loading"
                :hidden="qrCodeUrl !== null"
              >
                <font-awesome-icon
                  v-show="generatingQrCode"
                  :icon="['fas', 'spinner']"
                  spin
                />
                <span v-show="!generatingQrCode">GENERATE QR CODE</span>
              </button>

              <div style="display: block">
                <img
                  class="ml-2"
                  :src="qrCodeUrl"
                  alt="QR Code"
                  :hidden="qrCodeUrl == null"
                />
                <button
                  @click="downloadQrCode"
                  type="button"
                  class="btn m-1 btn-info tm-btn-red fixed-width-button"
                  :disabled="!course"
                  :hidden="!hasQrCodeUrl"
                >
                  <font-awesome-icon
                    v-show="generatingQrCode"
                    :icon="['fas', 'spinner']"
                    spin
                  />
                  <span v-show="!generatingQrCode">DOWNLOAD QR CODE</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.fixed-width-button {
  width: 180px;
}
</style>
